import React, { useState, useEffect } from "react";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../actions/CauHinhGoiTraGop";
import { formatNumber } from "utils/currencyFormat";
import Pagination from "react-js-pagination";
import { BtnThemMoi } from "./ThemMoi/BtnThemMoi";

export const TableDanhSach = ({
  quyenGopVon,
  quyenRutVon,
  quyenSuaNguonVon,
}) => {
  const dispatch = useDispatch();
  const listDanhSach = useSelector((state) => state.listCauHinhGoiTraGop);
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  useEffect(() => {
    dispatch(getListCauHinhGoiTraGop(dataSearch));
  }, []);

  const loadPage = () => {
    getListCauHinhGoiTraGop(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        iPageIndex: pageNumber,
      })
    );
    dispatch(getListCauHinhGoiTraGop(dataSearch));
    loadPage(dataSearch);
  };

  return (
    <>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="iconbutton-new  show-table-main">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <BtnThemMoi />
              </div>
              <div className="col-sm-12 col-md-3 d-flex just-end"></div>
            </div>
          </div>
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listDanhSach.isStartProcess ? "is-active" : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listDanhSach.iTotal} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-40 flex-basis-40-sm">
                    <p className="text-left">Tên sản phẩm</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-center">Số lượng gói</p>
                  </div>

                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable listDanhSach={listDanhSach.List} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {listDanhSach.iTotal === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.iPageIndex * dataSearch.iPageSize,
                      listDanhSach.iTotal
                    )}{" "}
                    / Tổng số {listDanhSach.iTotal}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (listDanhSach.iTotal === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.iPageIndex}
                    itemsCountPerPage={dataSearch.iPageSize}
                    totalItemsCount={listDanhSach.iTotal}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
